import { useEffect, useState } from 'react';

export const useWelcomePopup = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    useEffect(() => {
        // Check if user has already been contacted (localStorage) or seen popup in this session
        const hasBeenContacted = localStorage.getItem('contacted') === 'true';
        const hasSeenPopup = sessionStorage.getItem('hasSeenWelcomePopup');

        if (!hasBeenContacted && !hasSeenPopup) {
            // Show popup after a short delay to let the page load
            const timer = setTimeout(() => {
                setIsPopupOpen(true);
            }, 5000); // 5 seconds delay

            return () => clearTimeout(timer);
        }
    }, []);

    const closePopup = () => {
        setIsPopupOpen(false);
        // Mark that user has seen the popup in this session
        sessionStorage.setItem('hasSeenWelcomePopup', 'true');
    };

    const closePopupPermanently = () => {
        setIsPopupOpen(false);
        // Mark that user has seen the popup in this session
        sessionStorage.setItem('hasSeenWelcomePopup', 'true');
    };

    return {
        isPopupOpen,
        closePopup,
        closePopupPermanently,
    };
};
